<template>
    <div>
        <v-row>
            <v-col cols="6">
                <v-list-item>
                    <v-list-item-action>
                        <v-radio-group v-model="existingCustomer">

                            <v-radio :value="true"></v-radio>
                        </v-radio-group>
                    </v-list-item-action>

                    <v-list-item-content>
                        <v-list-item-title>Existing Customer</v-list-item-title>
                        <v-list-item-subtitle>Use the search below to find the customer.</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <CustomerSearch
                        @selected="selectedCustomer"
                        :disabled="!existingCustomer"
                />
            </v-col>
            <v-col cols="6">
                <v-list-item>

                    <v-list-item-action>
                        <v-radio-group v-model="existingCustomer">
                            <v-radio :value="false"></v-radio>
                        </v-radio-group>
                    </v-list-item-action>

                    <v-list-item-content>
                        <v-list-item-title>New Customer</v-list-item-title>
                        <v-list-item-subtitle>Use the search below to find the customer.</v-list-item-subtitle>
                    </v-list-item-content>

                </v-list-item>

            </v-col>
        </v-row>
            <v-row>
                <v-col cols="6">
                    <div class="d-flex align-center py-3">
                        <div>
                            <h2>Booker</h2>
                        </div>
                        <v-spacer/>
                        <v-btn
                                color="info"
                                dark
                                text
                                @click="copyBookerToInvoice"
                                :disabled="sameContact"
                                class="mb-3"

                        >
                            Copy To Invoice Contact <i class="fas fa-chevron-circle-right mr-2"></i>
                        </v-btn>
                    </div>
                    <BookerForm
                            :model="booking"
                            ref="bookerForm"
                    />
                </v-col>
                <v-col cols="6">

                    <div class="d-flex align-center py-3">
                        <div>
                            <h2>Invoice Contact</h2>
                        </div>
                        <v-spacer/>
                        <v-switch
                                v-model="sameContact"
                                label="Same as Booker"
                                class="ma-0"
                        />
                    </div>

                    <InvoiceContactForm
                            :model="booking"
                            :disabled="sameContact"
                            ref="invoiceContactForm"
                    />

                </v-col>

            </v-row>

    </div>
</template>

<script>
    import CustomerSearch from "../../AutoCompletes/CustomerSearch";
    import BookerForm from "../Forms/BookerForm";
    import InvoiceContactForm from "../Forms/InvoiceContactForm";

    let customerToBookingMap = [
        {from: 'company', to: 'contactCompany'},
        {from: 'contactName', to: 'contactName'},
        {from: 'contactEmail', to: 'contactEmail'},
        {from: 'contactAddress1', to: 'contactAddress1'},
        {from: 'contactAddress2', to: 'contactAddress2'},
        {from: 'contactAddress3', to: 'contactAddress3'},
        {from: 'contactTown', to: 'contactTown'},
        {from: 'contactCounty', to: 'contactCounty'},
        {from: 'contactPostcode', to: 'contactPostcode'},
        {from: 'contactPhone', to: 'contactPhone'},
        {from: 'company', to: 'invoiceCompany'},
        {from: 'accountsName', to: 'invoiceName'},
        {from: 'accountsEmail', to: 'invoiceEmail'},
        {from: 'accountsAddress1', to: 'invoiceAddress1'},
        {from: 'accountsAddress2', to: 'invoiceAddress2'},
        {from: 'accountsAddress3', to: 'invoiceAddress3'},
        {from: 'accountsTown', to: 'invoiceTown'},
        {from: 'accountsCounty', to: 'invoiceCounty'},
        {from: 'accountsPostcode', to: 'invoicePostcode'},
        {from: 'accountsPhone', to: 'invoicePhone'},
    ]


    export default {
        components: {CustomerSearch, BookerForm, InvoiceContactForm},
        props: {
            booking: {
                type: Object
            }
        },
        data() {
            return {
                sameContact: true,
                existingCustomer: true,
                bookerToInvoiceMap: [
                    {to: 'invoiceCompany', from: 'contactCompany'},
                    {to: 'invoiceName', from: 'contactName'},
                    {to: 'invoiceEmail', from: 'contactEmail'},
                    {to: 'invoiceAddress1', from: 'contactAddress1'},
                    {to: 'invoiceAddress2', from: 'contactAddress2'},
                    {to: 'invoiceAddress3', from: 'contactAddress3'},
                    {to: 'invoiceTown', from: 'contactTown'},
                    {to: 'invoiceCounty', from: 'contactCounty'},
                    {to: 'invoicePostcode', from: 'contactPostcode'},
                    {to: 'invoicePhone', from: 'contactPhone'},
                ],

            }
        },
        watch: {
            booking: {
                handler() {
                    if (this.sameContact) {
                        this.copyBookerToInvoice()
                    }
                },
                deep: true,
            },
            existingCustomer(value) {
                if(!value){
                    this.bookerToInvoiceMap.forEach((item) => {
                        this.booking[item.to] = ''
                        this.booking[item.from] = ''
                    })
                    this.booking.customer = null
                }
            }
        },
        methods: {
            validate() {
                return this.$refs.bookerForm.validate() || this.$refs.invoiceContactForm.validate()
            },

            selectedCustomer(customer) {
                this.booking.customer = customer.id
                this.sameContact = false

                customerToBookingMap.forEach((map) => {
                    this.booking[map.to] = customer[map.from]
                })

                this.bookerToInvoiceMap.forEach(map => {
                    if ((this.booking[map.to] === null || this.booking[map.to] === '')) {
                        this.booking[map.to] = this.booking[map.from]
                    }
                })
            },
            copyBookerToInvoice() {
                this.bookerToInvoiceMap.forEach(map => {
                    this.booking[map.to] = this.booking[map.from]
                })
            }
        },
    }
</script>

<style scoped>

</style>